import React, { ChangeEvent, FC, FocusEvent } from 'react'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { BsEye, BsEyeSlash } from 'react-icons/bs'

type PasswordInputProps = {
    id: string
    showPassword: boolean
    placeholder: string
    name: string
    value: string
    handleChange: (e: ChangeEvent<any>) => void
    handleBlur: (e: FocusEvent<any>) => void
    isInvalid: boolean
    toggleShowPassword: () => void
    autoComplete: string
}

const PasswordInput: FC<PasswordInputProps> = ({ id, showPassword, placeholder, name, value, handleChange, handleBlur, isInvalid, toggleShowPassword, autoComplete }) => {
    return (
        <InputGroup>
            <Form.Control
                id={id}
                type={showPassword ? 'text' : 'password'}
                placeholder={placeholder}
                name={name}
                autoComplete={autoComplete}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={isInvalid}
            />
            <Button
                variant="primary"
                type="button"
                onClick={toggleShowPassword}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
                {showPassword ? (
                    <BsEyeSlash aria-hidden="true" focusable="false" />
                ) : (
                    <BsEye aria-hidden="true" focusable="false" />
                )}
            </Button>
        </InputGroup>
    )
}

export default PasswordInput